import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { Reveal } from "../components/Motion";
import { INDUSTRIES } from "../lib/data";

export default function Industries() {
    return (
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10" data-testid="industries-page">
            <Seo title="Industries We Serve" description="The Puro Pack serves QSR, cloud kitchens, cafés, airline catering, grocery and institutional foodservice — from Bangalore to the world." path="/industries" />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Industries", to: "/industries" }]} />

            <section className="pt-14 pb-20 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-8">
                    <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Industries We Serve ]</div>
                    <h1 className="font-serif text-6xl lg:text-8xl leading-[0.95] tracking-tight text-forest">
                        Every kitchen has a <em className="italic">deadline.</em>
                    </h1>
                </div>
                <div className="lg:col-span-4 lg:pt-20">
                    <p className="text-inkgreen/80 leading-relaxed">
                        From 200-store QSR chains to two-person cloud kitchens, we build packaging programs that survive the pace of foodservice — high volumes, tight windows, zero compromises.
                    </p>
                </div>
            </section>

            <section className="pb-24">
                {INDUSTRIES.map((ind, i) => (
                    <Reveal key={ind.chapter} delay={i * 0.04}>
                        <div className={`border-t border-forest/30 py-14 grid lg:grid-cols-12 gap-8 lg:gap-14 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`industry-row-${ind.chapter}`}>
                            <div className="lg:col-span-6">
                                <div className="image-frame aspect-[4/3]">
                                    <img src={ind.image} alt={`${ind.title} — The Puro Pack sustainable paper packaging`} loading="lazy" />
                                </div>
                            </div>
                            <div className="lg:col-span-6">
                                <div className="font-mono text-6xl text-clay mb-6">[{ind.chapter}]</div>
                                <h3 className="font-serif text-4xl lg:text-5xl text-forest tracking-tight mb-5">{ind.title}</h3>
                                <p className="text-inkgreen/80 leading-relaxed text-lg max-w-xl">{ind.body}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </section>
        </div>
    );
}
